import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ICSAProductContextFacade } from 'dias-core/facades/icsa-product-context.facade';
import { Observable } from 'rxjs';

@Component({
  selector: 'custom-product-marketing-label',
  templateUrl: './product-marketing-label.component.html',
  providers: [ICSAProductContextFacade],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductMarketingLabelComponent implements OnInit {
  labels$: Observable<string[]>;

  constructor(private context: ICSAProductContextFacade) {}

  ngOnInit(): void {
    this.labels$ = this.context.getMarketingLabels$();
  }
}
